import EmployeeRow from '../EmployeeRow';
import {StyledRoundedButton} from '../styled';
import {EmployeeNames} from '../types';
import {Translate} from '@planday-corp/globalization';
import Text from '@planday-corp/ui/text/Text';
import {styled} from 'styled-components';
import {teamLabels} from '~/Signup/translations';

export const StyledText = styled(Text)`
  margin-bottom: 0.5rem;
`;

export const Wrapper = styled.div`
  margin-bottom: 1rem;
`;

interface PositionMembersListProps {
  position: string;
  assignedEmployees: EmployeeNames[];
  onChange: (position: string, employees: EmployeeNames[]) => void;
}

export default function PositionMembersList({
  position,
  assignedEmployees,
  onChange,
}: PositionMembersListProps) {
  const handleAddEmployeeRow = () => {
    onChange(position, [...assignedEmployees, {firstName: '', lastName: ''}]);
  };

  return (
    <Wrapper>
      <StyledText value={position} size="label" element="h4" />
      {assignedEmployees?.map((employeeNames, index) => (
        <EmployeeRow
          key={`${employeeNames.firstName}-${employeeNames.lastName}-${index}`}
          employeeNames={employeeNames}
          onChange={(updatedEmployee: EmployeeNames) => {
            const updatedEmployees = [...assignedEmployees];
            updatedEmployees[index] = updatedEmployee;
            onChange(position, updatedEmployees);
          }}
        />
      ))}
      <StyledRoundedButton
        iconRight="plusLarge"
        type="info"
        onClick={handleAddEmployeeRow}
      >
        <Translate {...teamLabels.addEmployee} />
      </StyledRoundedButton>
    </Wrapper>
  );
}
